import { StateCreator } from 'zustand';

export interface PaymentSlice {
  confirmationTokenId?: string;
  setConfirmationTokenId: (confirmationTokenId?: string) => void;
  confirmationLookup?: string;
  setConfirmationLookup: (confirmationLookup: string) => void;
}

export const createPaymentSlice: StateCreator<PaymentSlice, [], [], PaymentSlice> = (set) => ({
  confirmationTokenId: undefined,
  setConfirmationTokenId: (confirmationTokenId) => set({ confirmationTokenId }),
  confirmationLookup: undefined,
  setConfirmationLookup: (confirmationLookup) => set({ confirmationLookup }),
});
